const DANGEROUS_ELEMENTS = [
	'script',
	'style',
	'iframe',
	'object',
	'embed',
	'form',
	'link',
	'meta',
	'base',
]

const DANGEROUS_URI_PATTERN = /^\s*(?:javascript|vbscript|data):/i

const URI_ATTRIBUTES = ['href', 'src', 'xlink:href', 'formaction', 'action']

const FALLBACK_ELEMENT_PATTERN = new RegExp(
	`<\\s*(${DANGEROUS_ELEMENTS.join('|')})\\b[\\s\\S]*?<\\s*/\\s*\\1\\s*>`,
	'gi',
)

const FALLBACK_SELF_CLOSING_PATTERN = new RegExp(
	`<\\s*(${DANGEROUS_ELEMENTS.join('|')})\\b[^>]*/?>`,
	'gi',
)

const FALLBACK_EVENT_HANDLER_PATTERN =
	/\son\w+\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]+)/gi

const FALLBACK_DANGEROUS_URI_PATTERN =
	/\s(?:href|src|xlink:href|formaction|action)\s*=\s*(?:"\s*(?:javascript|vbscript|data):[^"]*"|'\s*(?:javascript|vbscript|data):[^']*'|\s*(?:javascript|vbscript|data):[^\s>]+)/gi

function sanitizeWithoutDom(content) {
	return content
		.replace(FALLBACK_ELEMENT_PATTERN, '')
		.replace(FALLBACK_SELF_CLOSING_PATTERN, '')
		.replace(FALLBACK_EVENT_HANDLER_PATTERN, '')
		.replace(FALLBACK_DANGEROUS_URI_PATTERN, '')
}

/**
 * Shared legal-content sanitization boundary. Removes active content
 * (scripts, event handlers, dangerous URIs, embedded objects) from
 * terms/privacy/e-sign HTML before it is handed to the BasicText renderer,
 * while preserving the intended static markup.
 */
export function sanitizeLegalContent(content) {
	if (typeof content !== 'string' || content.length === 0) {
		return content
	}

	if (
		typeof window === 'undefined' ||
		typeof window.DOMParser === 'undefined'
	) {
		return sanitizeWithoutDom(content)
	}

	const doc = new window.DOMParser().parseFromString(content, 'text/html')
	const body = doc && doc.body

	if (!body) {
		return sanitizeWithoutDom(content)
	}

	body.querySelectorAll(DANGEROUS_ELEMENTS.join(',')).forEach((node) => {
		node.remove()
	})

	body.querySelectorAll('*').forEach((element) => {
		Array.from(element.attributes).forEach((attribute) => {
			const name = attribute.name ? attribute.name.toLowerCase() : ''
			const value = attribute.value || ''
			if (name.startsWith('on')) {
				element.removeAttribute(attribute.name)
				return
			}
			if (URI_ATTRIBUTES.includes(name) && DANGEROUS_URI_PATTERN.test(value)) {
				element.removeAttribute(attribute.name)
			}
		})
	})

	return body.innerHTML
}

export default sanitizeLegalContent
